import dayjs from 'dayjs'
import 'dayjs/locale/zh-tw'
import relativeTime from 'dayjs/plugin/relativeTime'
import toObject from 'dayjs/plugin/toObject'
import isBetween from 'dayjs/plugin/isBetween'
import duration from 'dayjs/plugin/duration'

dayjs.locale('zh-tw')
dayjs.extend(relativeTime)
dayjs.extend(toObject)
dayjs.extend(isBetween)
dayjs.extend(duration)

/**
 * 日期格式化
 * @param timeStamp 十位时间戳
 * @param type  格式化类型  ，默认 YYYY-MM-DD
 */
export const dayjsFormat = (timeStamp: number | string, type = 'YYYY-MM-DD') => {
  if (!timeStamp) {
    return '--:--'
  }
  if (timeStamp.toString().length === 10) {
    timeStamp = Number(timeStamp) * 1000
  }
  return dayjs(timeStamp).format(type)
}
/**
 * 倒计时
 * @param diff 时间差
 * @param list 需要包含哪些 ['day','hours','minutes','seconds]
 */
export const dayjsCountdown = (diff: number) => {
  if (diff <= 0)
    return {
      day: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    }
  const diffTime = dayjs.duration(diff)
  const day = Math.floor(diffTime.asDays()) // 天
  const hours = diffTime.hours() // 小时
  const minutes = diffTime.minutes() // 分钟
  const seconds = diffTime.seconds() // 秒
  // let formatStr = '';
  return { day, hours, minutes, seconds }
}

export default dayjs
